"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBDocAnalysisPositive = function SvgBDocAnalysisPositive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M58.972 40.807H23.535a2.25 2.25 0 110-4.5h35.438a2.25 2.25 0 110 4.5zM83.79 54.975H23.535a2.25 2.25 0 110-4.5H83.79a2.25 2.25 0 110 4.5zM83.79 69.15H23.535a2.25 2.25 0 110-4.5H83.79a2.25 2.25 0 110 4.5zM83.79 83.317H23.535a2.25 2.25 0 110-4.5H83.79a2.25 2.25 0 110 4.5zM105.075 76.177a2.25 2.25 0 01-2.25-2.25l.045-67.5a1.2 1.2 0 00-1.2-1.2H79.83a2.25 2.25 0 110-4.5h21.84a5.708 5.708 0 015.7 5.7l-.045 67.5a2.25 2.25 0 01-2.25 2.25z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M101.632 143.468H5.7a5.708 5.708 0 01-5.7-5.7V27.848a2.25 2.25 0 012.25-2.25h22.59V13.68a2.25 2.25 0 114.5 0v14.168a2.25 2.25 0 01-2.25 2.25H4.5v107.67a1.2 1.2 0 001.2 1.2h95.932c.664 0 1.204-.537 1.208-1.2v-8.408a2.25 2.25 0 114.5 0v8.407a5.708 5.708 0 01-5.708 5.7z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M69.563 112.185a2.25 2.25 0 01-1.763-3.645 47.527 47.527 0 0169-5.895 2.25 2.25 0 11-3 3.345 43.028 43.028 0 00-62.468 5.348 2.25 2.25 0 01-1.77.847z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M105.075 129.375a47.46 47.46 0 01-31.808-12.218 2.25 2.25 0 013-3.344 43.02 43.02 0 0062.543-5.25 2.25 2.25 0 013.525 2.797 47.34 47.34 0 01-37.26 18.015z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M105.075 94.02a2.25 2.25 0 01-2.25-2.25v-5.1a2.25 2.25 0 114.5 0v5.1a2.25 2.25 0 01-2.25 2.25zM128.153 99.803a2.25 2.25 0 01-1.95-3.376l2.587-4.5a2.25 2.25 0 113.893 2.25l-2.58 4.463a2.25 2.25 0 01-1.95 1.163zM81.998 99.802a2.25 2.25 0 01-1.95-1.125l-2.58-4.462a2.25 2.25 0 013.892-2.25l2.588 4.5a2.25 2.25 0 01-1.95 3.375v-.038zM105.082 109.537a2.25 2.25 0 111.586-.653 2.25 2.25 0 01-1.6.653h.014z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M105.075 122.25c-8.24-.008-14.917-6.686-14.925-14.925a14.738 14.738 0 011.417-6.323 2.25 2.25 0 114.073 1.913 10.283 10.283 0 00-.99 4.41c0 5.758 4.667 10.425 10.425 10.425 5.758 0 10.425-4.667 10.425-10.425a10.282 10.282 0 00-.99-4.41 2.25 2.25 0 114.072-1.905 14.7 14.7 0 011.418 6.315c-.008 8.24-6.686 14.917-14.925 14.925z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M9.33 19.5a2.25 2.25 0 01-1.59-3.84L21.99 1.41a2.25 2.25 0 011.605-.66H82.5a2.25 2.25 0 010 4.5H24.525L10.92 18.855a2.25 2.25 0 01-1.59.645z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M2.25 143.452a2.25 2.25 0 01-2.25-2.25V84.75a2.25 2.25 0 114.5 0v56.475a2.25 2.25 0 01-2.25 2.227z",
    fill: "#285"
  })));
};

var _default = SvgBDocAnalysisPositive;
exports["default"] = _default;